/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementStrongIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementStrongIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.5 3.5V12.5H9.25C10.4926 12.5 11.5 11.4926 11.5 10.25V9.25C11.5 8.53018 11.162 7.88931 10.636 7.47746C10.8662 7.12446 11 6.70286 11 6.25V5.75C11 4.50736 9.99264 3.5 8.75 3.5H5.5ZM8.75 7C9.16421 7 9.5 6.66421 9.5 6.25V5.75C9.5 5.33579 9.16421 5 8.75 5H7V7H8.75ZM7 8.5V11H9.25C9.66421 11 10 10.6642 10 10.25V9.25C10 8.83579 9.66421 8.5 9.25 8.5H7Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementStrongIcon.tags = [
  'strong',
  'bold',
  'text',
  'letter',
  'typography',
  'font',
  'emphasis',
];

ElementStrongIcon.category = 'Navigator';

ElementStrongIcon.iconSize = 16;
